const KEY = 'ams1538.discoveries';

type Kept = Pick<Storage, 'getItem' | 'removeItem'> | null;

/** Places found before the book belonged to an account, kept in this browser until then. Only
 *  places of the city are read; unreadable or refused storage holds none. */
export function legacyFinds(known: readonly string[], storage: Kept): readonly string[] {
  try {
    const kept: unknown = JSON.parse(storage?.getItem(KEY) ?? '[]');
    return Array.isArray(kept)
      ? [
          ...new Set(
            kept.filter((id): id is string => typeof id === 'string' && known.includes(id))
          ),
        ]
      : [];
  } catch {
    return [];
  }
}

/** Once an account holds them, the browser's own copy is dropped. */
export function forgetLegacyFinds(storage: Kept): void {
  try {
    storage?.removeItem(KEY);
  } catch {
    /* Storage is optional in private browsing. */
  }
}
